import Component from '@glimmer/component'
import { fn } from '@ember/helper'
import { on } from '@ember/modifier'
import { eq, or } from 'ember-truth-helpers'
import UiButton from 'teacher-ui-client/components/ui-button'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'

export type ButtonValue = string | number
type ButtonOption<T> = { value: T; text: string | undefined }

interface Signature<T> {
  Element: HTMLDivElement
  Args: {
    value: T | null | undefined
    name?: string
    activeAppearance?: ButtonAppearance
    defaultAppearance?: ButtonAppearance
    onSelect: (value: T) => void
    buttons: ButtonOption<T>[]
    disabled?: boolean
  }
}

export class RadioButtonGroup<ValueType extends ButtonValue> extends Component<Signature<ValueType>> {
  <template>
    <div role="radiogroup" ...attributes>
      {{#each @buttons as |button|}}<UiButton
          data-test-selected={{eq @value button.value}}
          role="radio"
          name={{@name}}
          data-value={{button.value}}
          aria-checked="{{if (eq @value button.value) true false}}"
          {{! relative with focus:z-1 ensures the focus outline does not appear underneath adjacent buttons }}
          class="relative rounded-l-none rounded-r-none border-l-0 first:rounded-l-md first:border-l last:rounded-r-md focus:z-1"
          @appearance={{if
            (eq @value button.value)
            (or @activeAppearance ButtonAppearance.regular)
            (or @defaultAppearance ButtonAppearance.muted)
          }}
          @disabled={{@disabled}}
          {{on "click" (fn @onSelect button.value)}}
        >
          {{button.text}}
        </UiButton>{{/each}}
    </div>
  </template>
}

export default RadioButtonGroup
